var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
    for (var name in all) __defProp(target, name, {
      get: all[name],
      enumerable: !0
    });
  },
  __copyProps = (to, from, except, desc) => {
    if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from)) !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
      get: () => from[key],
      enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
    return to;
  };
var __toCommonJS = mod => __copyProps(__defProp({}, "__esModule", {
  value: !0
}), mod);
var subscribeToContextGroup_exports = {};
__export(subscribeToContextGroup_exports, {
  subscribeToContextGroup: () => subscribeToContextGroup
});
module.exports = __toCommonJS(subscribeToContextGroup_exports);
var import_useMedia = require("../hooks/useMedia.cjs"),
  import_createShallowSetState = require("./createShallowSetState.cjs");
const subscribeToContextGroup = ({
  setStateShallow,
  pseudoGroups,
  mediaGroups,
  componentContext,
  state
}) => {
  if (pseudoGroups || mediaGroups) return process.env.NODE_ENV === "development" && !componentContext.groups && console.debug("No context group found"), componentContext.groups?.subscribe?.((name, {
    layout,
    pseudo
  }) => {
    const current = state.group?.[name] || {
      pseudo: {},
      media: {}
    };
    if (pseudo && pseudoGroups?.has(String(name))) Object.assign(current.pseudo, pseudo), persist();else if (layout && mediaGroups) {
      const mediaState = (0, import_useMedia.getMediaState)(mediaGroups, layout),
        next = (0, import_createShallowSetState.mergeIfNotShallowEqual)(current.media, mediaState);
      next !== current.media && (Object.assign(current.media, next), persist());
    }
    function persist() {
      const group = {
        ...state.group,
        [name]: current
      };
      setStateShallow({
        group
      });
    }
  });
};